import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import GlobalContextProvider from './context/GlobalContext';
import I18n from "./i18n";
// import './i18n';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <GlobalContextProvider>
        {/* <App /> */}
        <I18n 
       render={(setLocale) => <App onLocaleChanged={setLocale} />} 
    />
      </GlobalContextProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
